class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.newestFetchData = null;
    this.lastPage = false;
    this.observer = null;
  }

  connectedCallback() {
    if(this.button) {
      this.button.addEventListener('click', () => this.handleButtonClick());
      if (this.dataset.nextUrl) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.newestFetchData && !this.lastPage && this.getHiddenProducts().length === 0) {
              this.fetchNextPage();
            }
          });
        })
        this.observer.observe(this.button);
      } else {
        this.lastPage = true;
      }
    }
  }

  getHiddenProducts() {
    return document.querySelectorAll('#product-grid .product-grid-item__to-load.hidden');
  }

  fetchNextPage() {
    if(!this.dataset.nextUrl) {
      console.warn('No next link available');
      return;
    }
    fetch(this.dataset.nextUrl)
      .then(response => {
        return response.text();
      })
      .then(html => { 
        const parser = new DOMParser();
        this.newestFetchData = parser.parseFromString(html, 'text/html');
      })
      .catch(error => {
        console.error(error);
      })
  }

  renderNewestContentIfExist() {
    const newItems = this.newestFetchData.querySelectorAll('#product-grid li');
    const newLoadMore = this.newestFetchData.querySelector('load-more');
    const list = document.querySelector('#product-grid');

    this.newestFetchData = null;

    newItems.forEach(item => list.appendChild(item));
    
    if(newLoadMore.dataset && newLoadMore.dataset.nextUrl) {
      this.setAttribute('data-next-url', newLoadMore.dataset.nextUrl);
    } else {
      this.clearButtonData();
    }
  }

  clearButtonData() {
    this.lastPage = true; 
    if(this.observer) this.observer.unobserve(this.button);
    this.button.remove();
    this.button = null
  }

  handleButtonClick() {
    const existingProductsToload = this.getHiddenProducts();
        
    if(existingProductsToload.length > 0) {
      existingProductsToload.forEach(item => item.classList.remove('hidden'));
      if (this.lastPage) this.clearButtonData();
    } else if(this.newestFetchData) {
      this.renderNewestContentIfExist()
    } else {
      this.clearButtonData();
    }
  }
}

customElements.define('load-more', LoadMore);